import { gql } from '@apollo/client';

export const GET_PSAS = gql`
  query GetPSAs($userLocation: [Float!]!, $radiusInKm: Float!) {
    getPSAs(userLocation: $userLocation, radiusInKm: $radiusInKm) {
      _id
      title
      description
      imageUrl
      location {
        type
        coordinates
      }
      startDate
      endDate
      createdAt
      updatedAt
    }
  }
`;

export const GET_PSA = gql`
  query GetPSA($_id: ID!) {
    getPSA(_id: $_id) {
      _id
      userId
      title
      description
      imageUrl
      location {
        type
        coordinates
      }
      startDate
      endDate
      createdAt
      updatedAt
      language
      expiresAt
      extensionCount
      lastExtendedAt
    }
  }
`;
